import React from "react";
import { connect } from "react-redux";
import ShowPageWrapper from "../shows/show_page_wrapper";
import { getShow, getEpisode } from "../../../action_managers/shows";
import { withRouter } from "react-router";
import { Grid, Row, Col } from "react-bootstrap";
import {
  getShowFromProps,
  getShowUUID,
  getEpisodeUUID,
  useGetEpisode,
  useGetShow,
} from "../../lib/getters_setters";
import {
  getEmbeddableDivClassName,
  getEmbeddableHTML,
  getEmbedSrc,
} from "../../../lib/copy_embedded_player";
import ClipboardJS from "clipboard";
import { showSuccess } from "../../../actions/app";
import "./episode_embed.scss";
import ExternalLink from "../../lib/external_link";
import { useComponentDidMount } from "../../../lib/hook";

const EpisodeEmbedPage = props => {
  useGetShow(props);
  useGetEpisode(props);

  let clipboard;
  useComponentDidMount(() => {
    clipboard = new ClipboardJS(".clipboard-js");
    clipboard.on("success", () => props.showSuccess("Copied to clipboard."));
    return () => {
      clipboard.destroy();
    };
  }, []);

  const showUUID = getShowUUID(props);
  const episodeUUID = getEpisodeUUID(props);
  const embeddableHTML = getEmbeddableHTML(showUUID, episodeUUID);

  useComponentDidMount(() => {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.onload = () => {
      window.redcircleIframe();
    };
    document.getElementById("script-container").appendChild(script);
    script.src = getEmbedSrc(showUUID, episodeUUID);
  });

  return (
    <ShowPageWrapper
      title={"Embed This Episode"}
      show={getShowFromProps(props)}
      backLink={`/shows/${showUUID}/ep/${episodeUUID}`}>
      <Grid fluid className={"episode-embed-page"}>
        <Row>
          <Col xs={12} md={12}>
            <div className={"text-center"}>
              This is code to embed a player for this episode on your website or blog. This will let
              you contact your listeners and provide them with updates. <br />
              <div className="margin-vert--medium">
                <ExternalLink
                  className="bold"
                  href="https://support.redcircle.com/en/articles/3093289-embedding-your-podcast-on-another-website">
                  Learn More
                </ExternalLink>
              </div>
              <button className="btn btn-primary clipboard-js" data-clipboard-text={embeddableHTML}>
                Copy HTML to clipboard
              </button>
            </div>
            <div id="script-container" />
            <div className={"preview-label bold"}>PREVIEW</div>
            <div
              className={`margin-top--small embed-container ${getEmbeddableDivClassName(
                episodeUUID
              )}`}
            />
          </Col>
        </Row>
      </Grid>
    </ShowPageWrapper>
  );
};

export default connect(
  state => ({
    shows: state.shows.shows,
    episodesByShowUUID: state.episodesByShowUUID,
  }),
  {
    showSuccess,
    getShow,
    getEpisode,
  }
)(withRouter(EpisodeEmbedPage));
